import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { AppButtonComponent } from "./app-button.component";



@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      IonicModule,
    ],
    exports: [AppButtonComponent],
    declarations: [AppButtonComponent]
  })
export class AppButtonModule {}